"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exerciseGoal = exports.getSummaryResults = exports.questions = void 0;

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "Great. Think of a current situation when you felt frustrated, irritated or disappointed with another person’s behaviour. Complete the following sentence: I’m feeling… with… because ….",
  type: "textAreaWithMore",
  meta: {
    answerLabel: "I’m feeling… with… because ….",
    summaryTitle: "The person I was challenged by was…"
  },
  options: [],
  moreInfoLabel: "Can you give me some examples?",
  moreInfo: ["Yes, here are some examples", "I feel frustrated with Dan because he didn’t do what I’d clearly asked him to do.", "Or, I feel frustrated with Paula because she doesn’t listen to me."],
  batteryId: "PERSPECTIVE_TAKING"
}, {
  prompt: "Think about the expectations that you had of the other person’s behaviour. Complete the following sentence: He/she should have or shouldn’t have… (what they did to upset you).",
  type: "textAreaWithMore",
  meta: {
    answerLabel: "He/she should have or shouldn’t have…",
    summaryTitle: "That person should or shouldn’t have"
  },
  moreInfoLabel: "Can you give me some examples?",
  options: [],
  moreInfo: ["Here are some examples: Dan shouldn’t have ignored me and done it his way.", "Or: Paula shouldn’t have spoken over me.", "She should have shown that she understands the way I feel."],
  batteryId: "PERSPECTIVE_TAKING"
}, {
  prompt: "Try to ignore all the reasons why you think their behaviour was wrong, and instead have a guess about the reasons why they feel their behaviour was justified. Write out your response using the following sentence: Because of current pressures on … such as …, he/she acted this way because …",
  type: "textAreaWithMore",
  meta: {
    answerLabel: "He/she should have or shouldn’t have…",
    summaryTitle: "That person should or shouldn’t have"
  },
  moreInfoLabel: "Can you give me some examples?",
  options: [],
  moreInfo: ["Here are some examples", "Because of current pressures on Dan such as trying to balance his family needs and work, he acted in this way because he ultimately decided that family was more important than work.", "Or, because of current pressures on Paula such as her feeling as though I’m not supporting her", "she acted in this way because she felt she wouldn’t be understood by me unless she spoke over me."],
  batteryId: "PERSPECTIVE_TAKING"
}, {
  prompt: "Write out your response using the following sentence: Because of past or childhood experiences like …, I can guess that he/she acted this way because …",
  type: "textAreaWithMore",
  meta: {
    answerLabel: "Because of past or childhood experiences like …, I can guess that he/she acted this way because …",
    summaryTitle: "The past reasons why that person felt their behaviour was justified were"
  },
  moreInfoLabel: "Can you give me some examples?",
  options: [],
  moreInfo: ["Here are some examples", "Because of past experiences like Dan’s divorce,", "I can guess that he acted in this way because he wants to keep his family as the top priority.", "Or, because of childhood experiences like Paula’s Mum always talking over her,", "I can guess she acted in this way because she thinks it’s normal to talk over people.", "Or, because of current pressures on Paula such as her feeling as though I’m not supporting her", "she acted in this way because she felt she wouldn’t be understood by me unless she spoke over me."],
  batteryId: "PERSPECTIVE_TAKING"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;
var exerciseGoal = "The goal was to build emotional intelligence and have better communication by practising how to understand someone else’s motivations.";
exports.exerciseGoal = exerciseGoal;